import { ReactNode } from "react";
import { Divider, Icon, Label, Tooltip } from "@shopify/polaris";
import styles from "./CommonFields.module.css";
import { InfoIcon } from "@shopify/polaris-icons";

const FormSubSection = ({
    children,
    rowLabel,
    isBundleBuilder,
    helpText,
    hideSeparator = false,
}: {
    children: ReactNode;
    rowLabel?: string;
    isBundleBuilder?: boolean;
    helpText?: string;
    hideSeparator?: boolean;
}) => {
    return (
        <div className={styles.commonFormRowParent} style={{ gridTemplateColumns: isBundleBuilder ? "1fr" : "" }}>
            {!!rowLabel?.length && (
                <div className={styles.customCardLabelWrapper} style={{ marginBottom: 4 }}>
                    <Label id="bundle_title">
                        {rowLabel}{" "}
                        {helpText?.length && (
                            <Tooltip content={helpText}>
                                <Icon source={InfoIcon} />
                            </Tooltip>
                        )}
                    </Label>
                </div>
            )}
            <div className={styles.commonFormRowChild} style={{ alignItems: "flex-start" }}>
                {children}
            </div>
            {!hideSeparator && (
                <div style={{ marginTop: 10 }}>
                    <Divider />
                </div>
            )}
        </div>
    );
};

export default FormSubSection;
